import { IntlShape, MessageDescriptor } from 'react-intl';

import { ReactTableTypes, CoreCommonMessages, CoreUtils } from '@nhl/nhl-breakaway-ui';

import commonMessages from '~/core/commonMessages';

const sortingMessages = commonMessages.tableHeaders.sorting;

const createAriaHeaderLabel =
    (intl: IntlShape, label: string) =>
    (isSortable: boolean, sortedState: ReactTableTypes.SortedState): string => {
        if (!isSortable) {
            return label;
        }

        const sortDirection = intl.formatMessage(
            sortedState?.desc ? sortingMessages.descending : sortingMessages.ascending
        );

        const sortOrder = sortedState?.index
            ? intl.formatMessage(CoreCommonMessages.misc.ordinal, { value: sortedState?.index + 1 })
            : null;

        return sortedState?.desc === undefined
            ? intl.formatMessage(sortingMessages.sortableColumn, { label })
            : intl.formatMessage(sortingMessages.sortedColumn, { label, sortDirection, sortOrder });
    };

export const addSortableHeaderTitle = (headerTitle: MessageDescriptor, intl: IntlShape): ReactTableTypes.MetaType => ({
    headerAriaLabel: createAriaHeaderLabel(intl, CoreUtils.safeFormatMessage(intl, headerTitle)),
    headerTitle: CoreUtils.safeFormatMessage(intl, headerTitle),
});
